export const mailAppName = "FbRW_b";
export default {mailAppName};